import { createClient } from "next-sanity"
import {
  SANITY_API_TOKEN,
  SANITY_DATASET,
  SANITY_PROJECT_ID,
} from "@/components/resources/constants"

if (!SANITY_DATASET) {
  throw new Error("Missing NEXT_PUBLIC_SANITY_DATASET")
}
if (!SANITY_PROJECT_ID) {
  throw new Error("Missing NEXT_PUBLIC_SANITY_PROJECT_ID")
}

export function getClient(draftMode: boolean = false) {
  return createClient({
    projectId: SANITY_PROJECT_ID, // you can find this in sanity.json
    dataset: SANITY_DATASET,
    useCdn: !draftMode, // `false` if you want to ensure fresh data,
    apiVersion: "2024-04-19", // use a UTC date string
    token: SANITY_API_TOKEN,
    perspective: draftMode ? "raw" : "published",
  })
}
